import { FeatureFlagName, FeatureFlagResponse, FeatureFlags } from './types';

import { apiSlice } from 'store/main/apiSlice';

const featureFlagApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureFlags: builder.query<FeatureFlags, void>({
      query: () => 'v1/toggles/',
      transformResponse: (response: FeatureFlagResponse[]) => {
        const flags = response.reduce((obj, curr) => ({ ...obj, [curr.name]: curr.toggleActive }), {});

        return {
          rsuSupport: !!flags[FeatureFlagName.RSU_SUPPORT],
          referralCode: !!flags[FeatureFlagName.REFERRAL_CODE],
          questionnaireTask: !!flags[FeatureFlagName.QUESTIONNAIRE_TASK],
          clientPortalHomeV2: !!flags[FeatureFlagName.CLIENT_PORTAL_HOME_V2],
        };
      },
    }),
    /**
     * NOTE: This query is only used in FeatureProxy component!
     */
    getFeatureFlagByName: builder.query<boolean, string>({
      query: (flagName: FeatureFlagName) => ({
        url: `v1/toggles/${flagName}/`,
        validateStatus: (): boolean => true, // Set all status codes to valid
      }),
      transformResponse: (response: FeatureFlagResponse) => !!response.toggleActive,
    }),
  }),
});

export const {
  useGetFeatureFlagsQuery,
  useLazyGetFeatureFlagsQuery,
  useGetFeatureFlagByNameQuery,
  reducer: featureFlagApiSliceReducer,
  reducerPath: featureFlagApiSliceReducerPath,
  middleware: featureFlagApiSliceMiddleware,
  util: featureFlagApiSliceUtil,
  endpoints: featureFlagApiSliceEndpoints,
} = featureFlagApiSlice;
